import {
  ICountry,
} from './authInterface';
import { RequestStatus } from 'mobx-store';

export interface IFeaturedArticlesStore {
  selectedFeaturedArticle: IFeaturedArticle;
  featuredArticlesList: IFeaturedArticle[];
  getFeaturedArticlesRequestStatus: RequestStatus;
  getFeaturedArticles: (countries: ICountry[], status?: 'all' | 'published' | 'unpublished', langCode?: string) => Promise<void>;
  getFeaturedArticleById: (featuredArticleId: number, langCode?: string) => Promise<void>;
  createFeaturedArticle: (newFeaturedArticle: CreateFeaturedArticleBody) => Promise<void>;
  updateFeaturedArticle: (featuredArticleId: number, updatedFeaturedArticle: UpdateFeaturedArticleBody, langCode: string) => Promise<void>;
  updateFeaturedArticleStatus: (updateFeaturedArticleStatus: boolean, index: number) => Promise<void>;
  getHistoryFeaturedArticles: (countries: ICountry[], langCode?: string) => Promise<void>;
}

export interface CreateFeaturedArticleBody {
  articleId: number;
  imageURL?: string;
  title: string;
  isActive: boolean;
}

export interface UpdateFeaturedArticleBody {
  articleId?: number;
  imageURL?: string;
  titleEn?: string;
  titleAr?: string;
  isActive?: boolean;
}

export interface IFeaturedArticle {
  featuredArticleId: number;
  isActive: boolean;
  imageURL?: string | File[];
  titleEn?: string;
  titleAr?: string;
  title?: string;
  article: IArticle;
}

export interface IArticle {
  createdAt?: string;
  articleId: number;
  isPublished?: boolean;
  type?: 'news' | 'announcement';
  imageURL?: string;
  videoURL?: string;
  articleCategory: IArticleCategory;
  titleAr?: string;
  previewAr?: string;
  bodyAr?: string;
  titleEn?: string;
  previewEn?: string;
  bodyEn?: string;
}

export interface IArticleCategory {
  articleCategoryId: number;
  titleAr?: string;
  titleEn?: number;
}

export const emptyArticleCategory: IArticleCategory = {
  articleCategoryId: -1,
};

export const emptyArticle: IArticle = {
  articleId: -1,
  articleCategory: emptyArticleCategory,
};

export const emptyFeaturedArticle: IFeaturedArticle = {
  featuredArticleId: -1,
  article: emptyArticle,
  isActive: false,
};

export const isImageString = (image: string | File[] | undefined): image is string => typeof image === 'string';

export const isImageArray = (image: string | File[] | string[] | undefined): image is File[] => Array.isArray(image);
